import { getLocalizationById } from '@context/useMyRouting/helpers';
import getLocalizationByArgs from '@helpers/getLocalizationByArgs';
import { ServiceField, ServiceFieldType } from '@onlog-public/additional-services-types';
import {
  SelectOption,
  optionsGeneratorProcessor,
} from '@pages/AdditionalServices/containers/services/optionsGenerator/types';
import { EcoFeePackagesLoaderResponse } from '@services/requests/searchLoaders/ecoFeeLoader/EcoFeePackagesLoaderQuery';
import i18next from 'i18next';

import { OptionsCache } from '../optionsLoader/types';

/**
 * EcoFeePackageProcessor реализует процессор генерации опций для упаковок экосбора
 */
export class EcoFeePackageProcessor implements optionsGeneratorProcessor {
  /**
   * getType возвращает тип поля, для которого реализован процессор
   */
  getType(): ServiceFieldType {
    return 'package';
  }

  /**
   * getOptions генерирует опции для селектора поля дополнительных услуг
   * @param field
   * @param langID
   * @param cache
   */
  getOptions(field: ServiceField, langID: string, cache: OptionsCache<any>): SelectOption[] {
    const langCode = getLocalizationById(langID).countryCode;
    const t = i18next.getFixedT(langCode);

    const packagesData: EcoFeePackagesLoaderResponse['items'] =
      field.handbook_limitations.length > 0
        ? field.handbook_limitations.map((id) => cache.cache[id]).filter((v) => !!v)
        : Object.values(cache.cache);

    return packagesData.map((d) => ({
      value: parseInt(d.id),
      label: `${t('Common:Package')}: ${getLocalizationByArgs(
        langID,
        d.default_name ?? '',
        d.localized_names_data
      )}`,
      description: `${t('Common:Group')} №${d.group.number_group} "${d.group.name ?? ''}" ${`/ ${t(
        'Common:RateValue'
      )}: ${d.group.rate_value ?? ''}  /  ${t('Common:Normative')}: ${
        d.group.normative_value ?? ''
      }  /  ${t('Common:Coefficient')}: ${d.group.coefficient ?? ''}`}`,
      origin: d,
    }));
  }
}
